import React from 'react'

export default function CircleCrossIcon({
  size = 15,
  className = 'text-[#C83F3F]',
  circleFillColor = '#C83F3F',
}) {
  return (
    <svg width={size} height={size} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M7.03125 0C3.14297 0 0 3.14297 0 7.03125C0 10.9195 3.14297 14.0625 7.03125 14.0625C10.9195 14.0625 14.0625 10.9195 14.0625 7.03125C14.0625 3.14297 10.9195 0 7.03125 0ZM7.03125 12.6562C3.93047 12.6562 1.40625 10.132 1.40625 7.03125C1.40625 3.93047 3.93047 1.40625 7.03125 1.40625C10.132 1.40625 12.6562 3.93047 12.6562 7.03125C12.6562 10.132 10.132 12.6562 7.03125 12.6562ZM9.55547 3.51562L7.03125 6.03984L4.50703 3.51562L3.51562 4.50703L6.03984 7.03125L3.51562 9.55547L4.50703 10.5469L7.03125 8.02266L9.55547 10.5469L10.5469 9.55547L8.02266 7.03125L10.5469 4.50703L9.55547 3.51562Z" fill={circleFillColor}/>
    </svg>
  )
}
